import NavBar from "./NavBar";
import Chips from "./Chips";
import BannerSlider from "./BannerSlider";
import ProductSlider from "./ProductSlider";
import Marquee from "./Marquee";
import ProductGrid from "./ProductGrid";
import SingleProduct from "./SingleProduct";
import SingleBanner from "./SingleBanner";
import BottomBar from "./BottomBar";
import PageHeader from "./PageHeader";
import CartItem from "./CartItem";
import CheckoutSummary from "./CheckoutSummary";
import CartHeader from "./CartHeader";
import MenuList from "./MenuList";
import SearchBar from "./SearchBar";
import NotificationItem from "./NotificationItem";
import AccountMenu from "./AccountMenu";
import AccountDetail from "./AccountDetail";
import Addresses from "./Addresses";
import AddressUpsert from "./AddressUpsert";
import Brand from "./Brand";
import Cart from "./Cart";
import Category from "./Category";
import Welcome from "./Welcome";
import Success from "./Success";
import Search from "./Search";
import Register from "./Register";
import ProductDetail from "./ProductDetail";
import Orders from "./Orders";
import Order from "./Order";
import Notifications from "./Notifications";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import Favorites from "./Favorites";
import LogoutModal from "./LogoutModal";
import DeleteAccountModal from "./DeleteAccountModal";
import FilterModal from "./FilterModal";
import SortModal from "./SortModal";

const Components = {
  NavBar: (props) => {
    return (
      <div>
        <NavBar {...props} />
      </div>
    );
  },
  Chips,
  BannerSlider,
  ProductSlider,
  Marquee,
  ProductGrid,
  SingleProduct,
  SingleBanner,
  BottomBar,
  PageHeader,
  CartItem,
  CheckoutSummary,
  CartHeader,
  MenuList,
  SearchBar,
  NotificationItem,
  AccountMenu,
  AccountDetail,
  Addresses,
  AddressUpsert,
  Brand,
  Cart,
  Category,
  Welcome,
  Success,
  Search,
  Register,
  ProductDetail,
  Orders,
  Order,
  Notifications,
  Login,
  ForgotPassword,
  Favorites,
  LogoutModal,
  DeleteAccountModal,
  FilterModal,
  SortModal,
};
export default Components;
